var confCurrent = {
  env: "PROD",
  subdomain: "",
  domain: "",
  contextBackApp: "",
  home: "",
  contextFrontApp: ""
}

var confLocal = {
  subdomain: "",
  domain: "192.168.0.34",
  contextBackApp: "/AppRapidiuxDir/",
  contextFrontApp: "",
  apiKeyMaps: ""
}

var confDev = {
  subdomain: "",
  domain: "192.168.1.74",
  contextBackApp: "/AppRapidiuxDir/",
  contextFrontApp: "",
  apiKeyMaps: ""
}

var confProd = {
  subdomain: "",
  domain: "rapidiux.com",
  contextBackApp: "/",
  contextFrontApp: "",
  apiKeyMaps: ""
}



export function getEnvironment(idDirectory) {

    var subdomain = "";

    if (confCurrent.env === "LOCAL") {
      confCurrent.apiKeyMaps = "AIzaSyBVQ3y24R3hjSs2kAKplvUTcQ5ODcP_57w";
      confCurrent.domain = confLocal.domain;
      confCurrent.subdomain = subdomain;
      confCurrent.contextBackApp = confLocal.contextBackApp;
      confCurrent.home = "http://" + subdomain + confLocal.domain + confLocal.contextBackApp;
      confCurrent.contextFrontApp = confLocal.contextFrontApp;
    }


    if (confCurrent.env === "DEV") {
      confCurrent.apiKeyMaps = "AIzaSyBVQ3y24R3hjSs2kAKplvUTcQ5ODcP_57w";
      confCurrent.domain = confDev.domain;
      confCurrent.subdomain = subdomain;
      confCurrent.contextBackApp = confDev.contextBackApp;
      confCurrent.home = "http://" + subdomain + confDev.domain + confDev.contextBackApp;
      confCurrent.contextFrontApp = confDev.contextFrontApp;
    }

    if (confCurrent.env === "PROD") {
      confCurrent.apiKeyMaps = "AIzaSyBtVEoE1dfattnIIMYRqWzetoaQl2yVRvg";
      confCurrent.domain = confProd.domain;
      confCurrent.subdomain = subdomain;
      confCurrent.contextBackApp = confProd.contextBackApp;
      confCurrent.home = "https://" + subdomain + confProd.domain + confProd.contextBackApp;
      confCurrent.contextFrontApp = confProd.contextFrontApp;
    }

    return confCurrent;
  }




//exports.developUrl = 'http://192.168.1.73/AppRapidiuxDir';
//exports.productionUrl = 'http://rapidiux.com';
//exports.devContextApp = '/';
//exports.prodContextApp = '/';
//exports.productionUrl = 'http://192.168.0.11:9090/insectv';
//exports.enviroment = 'DEV'; // values only     'PROD' for Production,     'DEV' for develop
